import { Action } from '@ngrx/store';
import { IUser } from 'src/app/models/user';

export enum ManageUserActionType {
  INIT_MANAGE_USER = '[Cyclops Manage User] Init Manage User',
  ADD_USER = '[Cyclops Manager User] Add User',
  ADD_USER_SUCCESS = '[Cyclops Manager User] Add User Success',
  ADD_USER_FAILURE = '[Cyclops Manager User] Add User Failure',

  BULK_ADD_USER = '[Cyclops Manager User] Bulk Add User',
  BULK_ADD_USER_SUCCESS = '[Cyclops Manager User] Bulk Add User Success',
  BULK_ADD_USER_FAILURE = '[Cyclops Manager User] Bulk Add User Failure',

  CHECK_EXISTING_USER = '[Cyclops Manager User] Check Existing User',
  CHECK_EXISTING_USER_SUCCESS = '[Cyclops Manager User] Check Existing User Success',
  CHECK_EXISTING_USER_FAILURE = '[Cyclops Manager User] Check Existing User Failure',

  USER_LIST = '[Cyclops Manager User] User List',
  USER_LIST_SUCCESS = '[Cyclops Manager User] User List Success',
  USER_LIST__SIM_SUCCESS = '[Cyclops Manager User] User List Sim Success',
  USER_LIST_ERROR = '[Cyclops Manager User] User List Error',

  USER_UPDATE = '[Cyclops Manager User] User Update',
  USER_UPDATE_SUCCESS = '[Cyclops Manager User] User Update Successfully',
  USER_UPDATE_ERROR = '[Cyclops Manager User] User Update Error',

  SPECIFIC_USER_DELETE = '[Cyclops Manager User] Specific User Delete ',
  SPECIFIC_USER_DELETE_SUCCESS = '[Cyclops Manager User] Specific User Delete Success',
  SPECIFIC_USER_DELETE_FAILURE = '[Cyclops Manager User] Specific User Delete Failed',

  USERS_EMAIL = '[Cyclops Manager User] Users Email ',
  USERS_EMAIL_SUCCESS = '[Cyclops Manager User] Users Email Successfully',
  USERS_EMAIL_ERROR = '[Cyclops Manager User] Users Email Error',

  ADD_ASSET_USER_PERMISSION = '[Cyclops Manager User] Add Asset User Permission ',
  ADD_ASSET_USER_PERMISSION_SUCCESS = '[Cyclops Manager User] Add Asset User Permission Successfully',
  ADD_ASSET_USER_PERMISSION_FAILURE = '[Cyclops Manager User] Add Asset User Permission Failed',
  RESET_STATE = '[Cyclops Manager User] Reset State',
}
export class ResetState implements Action {
  readonly type = ManageUserActionType.RESET_STATE;
  constructor(public payload: any) {}
}
export class InitManageUser implements Action {
  readonly type = ManageUserActionType.INIT_MANAGE_USER;
  constructor(public payload: any) {}
}
export class AddUser implements Action {
  readonly type = ManageUserActionType.ADD_USER;
  constructor(public payload: any) {}
}
export class AddUserSuccess implements Action {
  readonly type = ManageUserActionType.ADD_USER_SUCCESS;
  constructor(public payload: any) {}
}
export class AddUserFailure implements Action {
  readonly type = ManageUserActionType.ADD_USER_FAILURE;
  constructor(public payload: any) {}
}
export class BulkAddUser implements Action {
  readonly type = ManageUserActionType.BULK_ADD_USER;
  constructor(public payload: any) {}
}
export class BulkAddUserSuccess implements Action {
  readonly type = ManageUserActionType.BULK_ADD_USER_SUCCESS;
  constructor(public payload: any) {}
}
export class BulkAddUserFailure implements Action {
  readonly type = ManageUserActionType.BULK_ADD_USER_FAILURE;
  constructor(public payload: any) {}
}
export class CheckExistingUser implements Action {
  readonly type = ManageUserActionType.CHECK_EXISTING_USER;
  constructor(public payload: any) {}
}
export class CheckExistingUserSuccess implements Action {
  readonly type = ManageUserActionType.CHECK_EXISTING_USER_SUCCESS;
  constructor(public payload: any) {}
}
export class CheckExistingUserFailure implements Action {
  readonly type = ManageUserActionType.CHECK_EXISTING_USER_FAILURE;
  constructor(public payload: any) {}
}
export class UserList implements Action {
  readonly type = ManageUserActionType.USER_LIST;
  constructor(public payload: any) {}
}
export class UserListSuccess implements Action {
  readonly type = ManageUserActionType.USER_LIST_SUCCESS;
  constructor(public payload: any) {}
}
export class UserListSimSuccess implements Action {
  readonly type = ManageUserActionType.USER_LIST__SIM_SUCCESS;
  constructor(public payload: any) {}
}

export class UserListError implements Action {
  readonly type = ManageUserActionType.USER_LIST_ERROR;
  constructor(public payload: any) {}
}

export class UserUpdate implements Action {
  readonly type = ManageUserActionType.USER_UPDATE;
  constructor(public payload: any) {}
}
export class UserUpdateSuccess implements Action {
  readonly type = ManageUserActionType.USER_UPDATE_SUCCESS;
  constructor(public payload: IUser) {}
}
export class UserUpdateError implements Action {
  readonly type = ManageUserActionType.USER_UPDATE_ERROR;
  constructor(public payload: any) {}
}
export class SpecificUserDelete implements Action {
  readonly type = ManageUserActionType.SPECIFIC_USER_DELETE;
  constructor(public payload: any) {}
}
export class SpecificUserDeleteSuccess implements Action {
  readonly type = ManageUserActionType.SPECIFIC_USER_DELETE_SUCCESS;
  constructor(public payload: any) {}
}
export class SpecificUserDeleteFailure implements Action {
  readonly type = ManageUserActionType.SPECIFIC_USER_DELETE_FAILURE;
  constructor(public payload: any) {}
}
export class UsersEmail implements Action {
  readonly type = ManageUserActionType.USERS_EMAIL;
  constructor(public payload: any) {}
}

export class UsersEmailSuccess implements Action {
  readonly type = ManageUserActionType.USERS_EMAIL_SUCCESS;
  constructor(public payload: any) {}
}
export class UsersEmailError implements Action {
  readonly type = ManageUserActionType.USERS_EMAIL_ERROR;
  constructor(public payload: any) {}
}

export class AddAssetUserPermission implements Action {
  readonly type = ManageUserActionType.ADD_ASSET_USER_PERMISSION;
  constructor(public payload: any) {}
}

export class AddAssetUserPermissionSuccess implements Action {
  readonly type = ManageUserActionType.ADD_ASSET_USER_PERMISSION_SUCCESS;
  constructor(public payload: any) {}
}
export class AddAssetUserPermissionFailure implements Action {
  readonly type = ManageUserActionType.ADD_ASSET_USER_PERMISSION_FAILURE;
  constructor(public payload: any) {}
}

export type CyclopsManageUserActionUnion =
  | ResetState
  | InitManageUser
  | AddUser
  | AddUserSuccess
  | AddUserFailure
  | BulkAddUser
  | BulkAddUserSuccess
  | BulkAddUserFailure
  | UserList
  | UserListSuccess
  | UserListSimSuccess
  | UserListError
  | UserUpdate
  | UserUpdateSuccess
  | UserUpdateError
  | SpecificUserDelete
  | SpecificUserDeleteSuccess
  | SpecificUserDeleteFailure
  | UsersEmail
  | UsersEmailSuccess
  | UsersEmailError
  | CheckExistingUser
  | CheckExistingUserSuccess
  | CheckExistingUserFailure
  | AddAssetUserPermission
  | AddAssetUserPermissionFailure
  | AddAssetUserPermissionSuccess;
